import React from "react";
import "../AboutTaxes.css";

function FAQs() {
  return (
    <section className="blog-container">
      <div className="blog-header">
        <div className="blog-author">
          <div className="blog-author-profile">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Dollar_sign_in_circle_cleaned_%28PD_version%29.green.svg"
              alt="TaxSarthi"
            />
          </div>
          <div className="blog-author-name">TaxSarthi</div>
        </div>
        <div className="blog-date">12 July, 2023</div>
      </div>
      <hr />
      <div className="blog-title">Frequently Asked Questions</div>
      <hr />
      <div className="blog-content">
        <div className="content-section">
          <div className="content-subheading">
            What does the code EXC 001 mean in the income tax return notice?
          </div>
          <div className="content-paragraph">
            EXC-001 means that you have done a transaction that is beyond the
            permission of the&nbsp;
            <a
              href="https://tax2win.in/guide/income-tax-basics-comprehension-guide"
              target="blank"
            >
              Income Tax Act
            </a>
            . It is for cash transactions exceeding INR 10 lakh in a month
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            Does a salaried person get an income tax department notice?
          </div>
          <div className="content-paragraph">
            Yes, a salaried person can also get an income tax notice. The&nbsp;
            <a
              href="https://tax2win.in/guide/income-tax-notice-us-143-1"
              target="blank"
            >
              notice u/s 143(1)
            </a>
            &nbsp;is an intimation that ITD sends to every taxpayer. However,
            you can receive other income tax notices if ITD has reasons to
            believe that income has been concealed by you or on any other
            grounds.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do I check my tax notice?
          </div>
          <div className="content-paragraph">
            If ITD has issued any notice, it will be delivered to your
            registered email. You can check notices received by you through the
            income tax notification portal but remember, only some of the
            notices can be checked through the portal; for all notices
            inquiries, you can visit ITD and ask your query there. You can also
            check the authenticity of the notices issued by using “Authenticate
            notice/order issued by ITD” under quick links on the Income Tax
            website.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            Do I get income tax notices for current account transactions?
          </div>
          <div className="content-paragraph">
            Yes, the income tax notification department can issue ITR notices
            for current account transactions as well if it has a reason to do
            so. For example, any transaction exceeding Rs 50 lakhs in a current
            bank account in a financial year should be disclosed to ITD;
            otherwise, they may issue notice for the same.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is the communication of the proposed adjustment u/s 143(1)(a)
            of the Income Tax Act, 1961?
          </div>
          <div className="content-paragraph">
            The communication of proposed adjustment u/s 143(1)(a) of the Income
            Tax Act, 1961 refers to any information by the department that they
            are proposing some adjustment against refund claimed by you in
            your&nbsp;
            <a href="https://tax2win.in/guide/income-tax-return" target="blank">
              income tax return
            </a>
            &nbsp;, like the incorrect claim in ITR, disallowance of loss
            claimed in ITR, arithmetical error in ITR, etc. Such adjustment
            could be regarding any outstanding demand of previous assessment
            years.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How can I rectify the discrepancy received in u/s 143(1)?
          </div>
          <div className="content-paragraph">
            The Income Tax Department issued a discrepancy in notice u/s 143(1),
            and the discrepancy can be favorable or not. If any demand raised is
            correct, then pay the same. IT will certainly pay you if any refund
            is INR 100 or more. If any mistake is apparent from the record, you
            can file &nbsp;
            <a
              href="https://tax2win.in/guide/rectify-income-tax-return-u-s-154-1-rectification-request"
              target="blank"
            >
              rectification u/s 154 (1)
            </a>
            &nbsp;intimating the correction of mistakes: Click on ‘e-file’ and
            choose the ‘Rectification’ option from the drop-down list.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How long after I file tax returns should I be prepared for any kind
            of scrutiny or assessment notice from the Income Tax Department?
          </div>
          <div className="content-paragraph">
            A &nbsp;
            <a
              href="https://tax2win.in/guide/income-tax-notice-us-143-2"
              target="blank"
            >
              notice u/s 143(2)
            </a>
            &nbsp;for scrutiny assessment can only be issued up to a period of
            six months from the end of the financial year in which you furnished
            the return.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What to do if I get a tax notice?
          </div>
          <div className="content-paragraph">
            If you get an income tax notification, you should understand why the
            notice has been sent. Notices may be sent due to various reasons.
            For example, Notices may be sent for the details and papers required
            by the Income Tax Department, and it still needs to be submitted. In
            such a case, you need to provide the details as required. If there
            is any error in the ITR, then notices may be sent to rectify the
            error. In such a case, you should rectify any error in your return
            and respond to the notice within the time specified by the income
            tax department to avoid possible penalties.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What happens if you don't respond to the tax notice?
          </div>
          <div className="content-paragraph">
            If you don't respond to the income tax notice, there can be
            different types of consequences depending upon the type of Notice
            you have received. Such consequences include fines of up to INR
            10,000 and also imprisonment for up to a year.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is an intimation letter from income tax?
          </div>
          <div className="content-paragraph">
            The income tax department issues an intimation letter/notice under
            section 143(1) after your return is successfully processed. It has
            the details of the information you submitted at the time of filing
            of ITR and a corresponding column showing the details as per
            information available with the tax department. This intimation has
            to be sent within one year from the end of the financial year in
            which the return is being filed.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">How do you reply to notice?</div>
          <div className="content-paragraph">
            You can reply to an income tax notice online. You can visit the
            online website of the income tax department, which is used for the
            e-filing of returns. Log into your online account, go to the
            compliance section, and respond to the notice you have received.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do I pay my tax on demand?{" "}
          </div>
          <div className="content-paragraph">
            You can pay your tax on-demand online. To do so, you can visit the
            e-filing website of the income tax department and log into your
            account. You can then check the amount of outstanding tax demand
            under Response to Outstanding Tax Demand under the pending actions
            option. Then, under the Pay Now column, choose Click Here. You would
            be taken to the NSDL website to fill out the online form and pay the
            tax on demand. Also, you can directly pay tax by clicking the Pay
            Now option for the respective DRN (Demand Reference Number) on the
            Response to Outstanding Demand page.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What happens if I don't respond to the notice within 30 days?
          </div>
          <div className="content-paragraph">
            If you don't respond to the notice within 30 days, the income tax
            department will adjust if there is some outstanding demand without
            giving any further opportunity to respond.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do I get my CPC income tax return?
          </div>
          <div className="content-paragraph">
            <a
              href="https://tax2win.in/guide/itr-v-acknowledgement"
              target="blank"
            >
              ITRV (acknowledgment)
            </a>
            &nbsp;is received on your registered mail ID soon after you file
            ITR. Otherwise, it can also be downloaded from your account on
            income tax India's official website.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do you correct outstanding tax demand?
          </div>
          <div className="content-paragraph">
            To submit your response for outstanding tax demand online
            <div className="content-ul">
              <li>
                Log in to the income tax India efiling website using your PAN
                and password
              </li>
              <li>
                Go to the pending actions section from the top bannerSelect
                Response to Outstanding Tax Demand and proceed.
              </li>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="blog-footer">
        <div className="blog-author">
          <div className="blog-author-profile">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Dollar_sign_in_circle_cleaned_%28PD_version%29.green.svg"
              alt="TaxSarthi"
            />
          </div>
          <div className="blog-author-name">TaxSarthi</div>
        </div>
        <div className="next-button">
          <button>Next</button>
        </div>
      </div>
    </section>
  );
}

export default FAQs;
